export const SET_REDIRECTION = "SET_REDIRECTION"

export interface SetRedirectionAction {
  type: typeof SET_REDIRECTION
  payload: string
}

export type RedirectionActionTypes = SetRedirectionAction
